import { useMutation, useQueryClient } from '@tanstack/react-query';
import LocationService from '@clickersphere/core/services/LocationService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { LOCATIONS_QUERY_KEY, LocationQueryData } from './useLocations';

export function useDeleteLocation() {
  const queryClient = useQueryClient();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    isPending: deleteLocationIsPending,
    mutateAsync: deleteLocationAsync,
  } = useMutation({
    mutationFn: async (id: string) => LocationService.remove(id),
    onMutate: async (id) => {
      await queryClient.cancelQueries({
        queryKey: buildQueryKey(LOCATIONS_QUERY_KEY),
      });

      const oldLocations = queryClient.getQueryData<LocationQueryData[]>(
        buildQueryKey(LOCATIONS_QUERY_KEY),
      );

      queryClient.setQueryData<LocationQueryData[]>(
        buildQueryKey(LOCATIONS_QUERY_KEY),
        (old) => old?.filter((location) => location.id !== id),
      );

      return { oldLocations };
    },

    onError: async (_error, _id, context) => {
      await queryClient.cancelQueries({
        queryKey: buildQueryKey(LOCATIONS_QUERY_KEY),
      });

      queryClient.setQueryData(
        buildQueryKey(LOCATIONS_QUERY_KEY),
        context?.oldLocations,
      );
    },
  });

  return {
    deleteLocationAsync,
    deleteLocationIsPending,
  };
}
